// product-utils.js
"use strict;"

import $ from "jquery";

export const doNotifications = (function (res) {
    if (typeof res.Notifications === "undefined") {
        return;
    }
});

export const productPricing = (function () {

    var isMobile = $(window).width() < 768;

    $("div.update-pricing").each(function () {
        var $product = $(this);
        var productCode = $product.attr("data-product");

        $.ajax({ url: "/api/ssi/pricing/" + productCode }).done(function (pricing) {
            var $priceNow = $product.find(".price.price-now");
            $priceNow.html(pricing["Now"]["Formatted"]);
            $priceNow.attr("data-standard-price", pricing["Now"]["EffectivePrice"]["StandardPrice"]);

            if (typeof pricing["Before"] !== "undefined" && pricing["Before"] !== null) {
                var $oldPrice = $product.find(".price.price-old");

                $oldPrice.html(pricing["Before"]["Formatted"]);
                $oldPrice.removeClass("hidden");

                var allowChange = true;

                if (isMobile) {

                    var right = $oldPrice.outerWidth() - parseInt($oldPrice.css("padding-right"));
                    var left = $priceNow.parent().innerWidth() - $priceNow.outerWidth() + parseInt($priceNow.css("padding-left"));

                    if (right > (left - 5)) {
                        console.log("Blocking as overlaps: " + productCode);
                        $oldPrice.addClass("hidden");
                        allowChange = false;
                    }
                }

                if (allowChange) {
                    $priceNow.addClass("price-has-old-price");
                }
            }

            $product.removeClass("update-pricing");
        });
    });
});

export default {
    productPricing,
    doNotifications
};